import Button from 'components/Button'
import Card from 'components/Card'
import CountDowntimer from 'components/CountDownTimer'
import PublicPageWrapper from 'components/PublicPagesWrapper'
import { SemiTitle, Text } from 'components/Typography'
import logo from 'images/guigo_partners_black.svg'
import React from 'react'
import { Box, Flex } from 'reflexbox/styled-components'
import theme from 'styles/theme'
import { TextInformer } from './styles'

const Login = () => {
  const redirect = href => {
    window.location.href = href
  }
  return (
    <PublicPageWrapper>
      <CountDowntimer />
      <Card minWidth={384} p={32} bg='white'>
        <Flex flexDirection='column' alignItems='center' justifyContent='center' mb={24}>
          <Box mb={32}>
            <img src={logo} />
          </Box>
          <Box mb={32}>
            <SemiTitle textAlign='center' color={theme.colors.turquoises.T300} as='h3'>
              Bem-vindo
            </SemiTitle>
            <TextInformer>
              <Text>
                Para melhor atendê⁻los, fizemos algumas modificações. Clique no botão referente ao seu contrato, que
                você será redirecionado para o novo link.
              </Text>
            </TextInformer>
          </Box>
          <Flex width={1} justifyContent='center'>
            <Button size='auto' onClick={() => redirect('https://parceiros-prepago.guigo.tv')}>
              Parceiro Pré-pago
            </Button>
            <Button size='auto' onClick={() => redirect('https://parceiros-pospago.guigo.tv')}>
              Parceiro Pós-pago
            </Button>
          </Flex>
        </Flex>
      </Card>
    </PublicPageWrapper>
  )
}

export default Login
